module.exports = __webpack_public_path__ + "img/ferdi-kaza-sigortasi.7b22f20f.png";